import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme, type ThemePreference } from '@/hooks/useTheme'
import { Button } from '@/components/ui/button'

const CYCLE: ThemePreference[] = ['light', 'dark', 'system']
const ICONS: Record<ThemePreference, typeof Sun> = { light: Sun, dark: Moon, system: Monitor }
const LABELS: Record<ThemePreference, string> = { light: 'Light', dark: 'Dark', system: 'System' }

/** Compact icon button for the top nav — cycles Light -> Dark -> System on each click.
 *  The full 3-way control lives in Settings > Profile; this is the always-visible shortcut. */
export function ThemeToggleButton() {
  const { preference, setPreference } = useTheme()
  const Icon = ICONS[preference]

  function cycle() {
    const next = CYCLE[(CYCLE.indexOf(preference) + 1) % CYCLE.length]
    setPreference(next)
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      onClick={cycle}
      tooltip={`Theme: ${LABELS[preference]}`}
      aria-label={`Theme: ${LABELS[preference]}. Click to change.`}
      className="shrink-0 rounded-lg text-[var(--fl-text-2)]"
    >
      <Icon size={16} />
    </Button>
  )
}
